import axios from "axios";

const BASE_URL = "https://youtube-v31.p.rapidapi.com"

const options = {
    url: BASE_URL,
    params: {
      maxResults: '50'
    },
    headers: {
      'X-RapidAPI-Key': "8beb8ea62emsh903c96f2c991011p1c5716jsnb14773f36a97",
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
};

export const fetchFromAPI = async (url) => {
    //console.log(process.env.REACT_APP_RAPID_API_KEY)
    const {data} = await axios.get(`${BASE_URL}/${url}`, options);

    return data;
}